import React from 'react';

export default function Writer() {
  return(
    <>
      <h1>Writer</h1>
    </>
  );
}